import React, { useEffect, useState } from "react";
import { Button, Select } from "antd";
import { useNavigate } from "react-router-dom";
import "../../Css/NewHome/NewBanner.css";
import "../../Css/HomePage.css";
import image from "../../Images/banner/heroBanner.png";
import { IoCheckmarkDoneCircle } from "react-icons/io5";
import { get } from "../../services/ApiRouting";
import { getStateOptions, getCityOptions } from "../StateArray";

const NewBanner = () => {
  const [categoryList, setCategoryList] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);

  console.log(selectedState);

  const checkList = [
    "Wedding Venues",
    "Catering Services",
    "Photography",
    "Decoration",
    "Makeup Artists",
    "Event Planning",
    "Entertainment",
    "Wedding Attire",
    "Floral Arrangements",
    "Sound and Lighting",
    "Wedding Cakes",
    "Bridal Accessories",
  ];

  const navigate = useNavigate();

  const [search, setSearch] = useState("");

  // Fetch categories
  const categoryFetch = async (search) => {
    try {
      const response = await get(
        `categories?page=0&limit=100${search !== "" ? "&search=" + search : ""}`
      );
      setCategoryList(response?.data);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  useEffect(() => {
    const dbounce = setTimeout(() => categoryFetch(search), 300);
    return () => clearTimeout(dbounce);
  }, [search]);

  // Handle Search Button Click
  const handleSearch = () => {
    if (!selectedCategory) {
      alert("Please select a category.");
      return;
    }

    navigate(
      `/vendors?category=${selectedCategory}&state=${selectedState}&city=${selectedCity}`
    );
  };

  return (
    <section className="home-new-banner-main-con">
      <div className="container h-100">
        <div className="row h-100">
          <div className="col-lg-5 d-lg-none d-flex align-items-center justify-content-center p-0">
            <img src={image} />
          </div>
          <div className="col-lg-7 p-0">
            <div className="new-home-banner-main-con">
              <div className="new-home-banner-main-search-con">
                <div className="new-banner-home-page-content">
                  <h1>Crafting Unforgettable Moments, One Vendor at a Time</h1>
                  <p>
                    From stunning venues to talented photographers —
                    Weddingz.adda connects you with the best to turn your love
                    story into a magical celebration.
                  </p>
                </div>
                <br />
                <h2 style={{ fontSize: "1.2rem" }}>Search Vendors</h2>
                <div className="home-search-bar">
                  <div className="row">
                    <div className="col-md-6 mx-0 px-0 mb-1">
                      <Select
                        width={"100%"}
                        showSearch
                        onSearch={setSearch}
                        searchValue={search}
                        placeholder="Select Category"
                        onChange={(value) => {
                          const selected = categoryList?.find(
                            (cat) => cat.slug == value
                          );
                          setSelectedCategory(selected?.name || "");
                        }}
                        options={categoryList?.map((category) => ({
                          value: category.slug,
                          label: category.name,
                        }))}
                      />
                    </div>
                    <div className="col-md-6 mx-0 px-0 mb-1">
                      <Select
                        showSearch
                        placeholder="Select State"
                        onChange={(value) => setSelectedState(value)}
                        options={getStateOptions()}
                        width={"100%"}
                        value={selectedState}
                      />
                    </div>
                    <div className="col-md-6 mx-0 px-0">
                      <Select
                        placeholder="Select City"
                        onChange={(value) => setSelectedCity(value)}
                        options={getCityOptions(selectedState)}
                        className="w-100"
                      />
                    </div>
                    <div className="col-md-6 mx-0 px-0">
                      <Button className="w-100" onClick={handleSearch}>
                        Get Started
                      </Button>
                    </div>
                  </div>
                </div>
                <br />
                <br />
                <div className="new-banner-home-page-content d-md-block d-none">
                  <h2>Make Sure to Check Off Your Event Vendor List</h2>
                  <p style={{ fontSize: ".85rem", maxWidth: 600 }}>
                    Plan stress-free! From venue to photography — find and book
                    trusted vendors for every detail of your big day.
                  </p>
                  <div className="row" >
                    {checkList.map((item, index) => (
                      <div className="col-lg-4 col-md-6" key={index}>
                        <IoCheckmarkDoneCircle
                          style={{ marginRight: 10, color: "green" }}
                        />
                        <span>{item}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-5 d-lg-flex d-none align-items-center justify-content-center p-0">
            <img src={image} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewBanner;
